<div class="flex-header mat-dialog-title">
    <span>Archive Report</span>
    <!-- <span *ngIf="!newFile">Edit Document</span> -->
</div>

<div class="flex-content" style="width:700px;">

        <!-- FILENAME FIELD IS SHARED FOR ALL THREE ARCHIVE OPTIONS -->
        <div>
            <span style="font-weight: bold;">{{reportName}}</span><br />
            <tyl-form-field label="File Name" style="width: 100%;"
                hint="{{100 - (fileNameString ? fileNameString.length : 0)}} characters left">
                <textarea matInput #fileNameInput [(ngModel)]="fileNameString" maxlength="100" id="fileNameInput"
                    name="FileName" required rows="2">
                </textarea>
            </tyl-form-field>
            <!-- <tyl-form-field label="Archive Batch Description" style="width: 100%;"
                hint="{{100 - (batchDescription ? batchDescription.length : 0)}} characters left">
                <textarea matInput #fileNameInput [(ngModel)]="batchDescription" maxlength="100" id="batchDescription"
                    name="batchDescription" required rows="2">
                </textarea>
            </tyl-form-field> -->
            <!-- [disabled]="(!archiveToStudentDigitalContent && !archiveToStudentPortfolio && !archiveToTCM)" -->


        </div>
        <!-- <div>
            <tyl-form-field label="Description" style="width: 100%;"
                hint="{{500 - (descriptionString ? descriptionString.length : 0)}} characters left">
                <textarea matInput #descriptionInput [(ngModel)]="descriptionString" maxlength="500"
                    id="DescriptionInput" name="Description" rows="4">
            </textarea>
            </tyl-form-field>
        </div> -->
        <!-- [disabled]="!allowArchiveToStudentDigitalContent || !archiveToStudentDigitalContent" -->


        <table style="width: 100%;">

            <!-- ARCHIVE TO STUDENT DIGITAL CONTENT -->
            <tr [style.display]="allowArchiveToStudentDigitalContent ? null : 'none'">
                <td style="width: 33%;">
                    <tyl-checkbox *ngIf="!isForSchedule" [(checked)]="archiveToStudentDigitalContent"
                        id="archiveToStudentDigitalContent_ID" translate name="archiveToStudentDigitalContent"
                        [disabled]="!allowArchiveToStudentDigitalContent"
                        (change)="archiveToStudentDigitalContentChecked($event);">
                        Archive in Student Digital Content
                    </tyl-checkbox>
                </td>
                <td style="width: 64%; padding-left: 10px;">
                    <tyl-form-field label="Document Type">
                        <mat-select #documentTypeInput [(ngModel)]="documentTypeIdString" name="DocumentType"
                            id="documentTypeSelect" required
                            (ngModelChange)="checkInputs()"
                            [disabled]="!allowArchiveToStudentDigitalContent || !archiveToStudentDigitalContent">
                            <mat-option *ngFor="let type of documentTypes; let i = index" value="{{type.Id}}">
                                <span>{{type.CodeDescription}}</span>
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>
                </td>
            </tr>

            <!-- ARCHIVE TO STUDENT PORTFOLIO-->
            <tr [style.display]="allowArchiveToStudentPortfolio ? null : 'none'">
                <td style="width: 33%;">
                    <tyl-checkbox *ngIf="!isForSchedule" [(checked)]="archiveToStudentPortfolio"
                        id="archiveToStudentPortfolio_ID" [disabled]="!allowArchiveToStudentPortfolio" translate
                        name="archiveTo_StudentPortfolio" (change)="archiveToStudentPortfolioChecked($event);">
                        Archive in Student Portfolio
                    </tyl-checkbox>
                </td>
                <td style="width: 64%; padding-left: 10px">
                    <tyl-form-field label="Document Type">
                        <mat-select #fileCategoryInput [(ngModel)]="fileCategoryId" name="selectPortfolioCategory"
                            id="selectCategory_ID" required
                            (ngModelChange)="checkInputs()"
                            [disabled]="!allowArchiveToStudentPortfolio || !archiveToStudentPortfolio">
                            <mat-option *ngFor="let category of portfolioCategories; let i = index"
                                value="{{category.StuPortCategory_ID}}">
                                <span>{{category.StuPortCategoryName}}</span>
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>
                </td>
            </tr>

            <!-- ARCHIVE TO TCM-->
            <tr [style.display]="allowArchiveToTCM ? null : 'none'">
                <td style="width: 33%;">
                    <tyl-checkbox *ngIf="!isForSchedule" [(checked)]="archiveToTCM" id="archiveToTCM_ID"
                        [disabled]="!allowArchiveToTCM" translate name="archiveToTCM"
                        (change)="archiveToTCMChecked($event);">
                        Archive in Tyler Content Manager
                    </tyl-checkbox>
                </td>
                <td style="width: 64%; padding-left: 10px">
                    <tyl-form-field label="Document Type">
                        <mat-select #documentTypeTCMInput [(ngModel)]="selectedTCMdocument" name="TCMDocumentType"
                            (ngModelChange)="checkInputs()"
                            id="tcmDocumentTypeSelect" required [disabled]="!allowArchiveToTCM || !archiveToTCM">
                            <mat-option *ngFor="let docType of tcmDocumentTypes; let i = index"
                                value="{{docType.ValueField}}">
                                <span>{{docType.TextField}}</span>
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>
                </td>
            </tr>

        </table>


        <table style="width:98%; margin-left:10px;" st-select-row="parameterRow" st-select-mode="single">

            <!-- *************** SEND TO EMAIL *************** -->

            <!-- [ngClass]="{'tableOddRow': !isEven($index +1), 'tableEvenRow': isEven($index +1)}" -->
            <tr *ngIf="MailServer > '' && allowArchiveToStudentPortfolio" style="width:100%;">

                <td>
                    <tyl-checkbox  [(checked)]="sendEmailNotification" id="sendEmailNotification_ID" [disabled]='!archiveToStudentPortfolio'
                            name="sendEmailNotification" > <!-- (change)="isDebugModeInProductionChecked($event)" -->
                        Send Email Notifications (Only for Student Portfolio)
                    </tyl-checkbox>

                    <!-- <mat-checkbox [(ngModel)]="selectedReport.SendToEmail">Send Report To Email(s)</mat-checkbox> -->


                    <div>
                        <!-- [pattern]="getEmailRegexp()" -->
                        <!-- Multiline Textboxes -->
                        <tyl-form-field label="Email From:" style="width: 100%;">
                            <textarea matInput [(ngModel)]="emailFrom" name="EmailFrom" required
                                #EmailFromRef [disabled]='!archiveToStudentPortfolio'
                                 [pattern]="getEmailRegexp()" autoComplete="off" autoCorrect="off"
                                autoCapitalize="off" spellCheck="false" maxLength="300" rows="1"
                                placeholder="Enter Email From">
                        </textarea>
                        </tyl-form-field>
                        Send emails to:
                        <!-- <tyl-form-field label="Notify Email(s):" style="width: 100%;"></tyl-form-field> -->
                            <tyl-checkbox  [(checked)]="sendEmailStudent" id="sendEmailStudent_ID" [disabled]='!archiveToStudentPortfolio'
                                name="sendEmailStudent" >
                                Student
                            </tyl-checkbox>
                            <tyl-checkbox  [(checked)]="sendEmailPrimaryContact" id="sendEmailPrimaryContactn_ID" [disabled]='!archiveToStudentPortfolio'
                                name="sendEmailPrimaryContact" >
                                Primary Contact
                            </tyl-checkbox>
                            <tyl-checkbox  [(checked)]="sendEmailAllElectronicContacts" id="sendEmailAllElectronicContacts_ID" [disabled]='!archiveToStudentPortfolio'
                                name="sendEmailAllElectronicContacts" >
                                All Electronic Contacts
                            </tyl-checkbox>
                            <!-- <textarea matInput [(ngModel)]="selectedReport.EmailsToSendReport" name="EmailsToSendReport"
                                required [pattern]="getEmailRegexp()" #emailsToSendReport autoComplete="off"
                                autoCorrect="off" autoCapitalize="off" spellCheck="false" maxLength="4000" rows="2"
                                placeholder="Enter email(s) to send this report">
                        </textarea> -->
                        
                        <tyl-form-field label="Email Subject:" style="width: 100%;">
                            <textarea matInput [(ngModel)]="emailSubject" name="EmailSubject" required [disabled]='!archiveToStudentPortfolio'
                                #EmailSubjectRef maxLength="2000" rows="1" placeholder="Enter email subject">
                        </textarea>
                        </tyl-form-field>
                        <tyl-form-field label="Email Body:" style="width: 100%;">
                            <textarea matInput [(ngModel)]="emailBody" name="EmailBody" maxLength="500" [disabled]='!archiveToStudentPortfolio'
                                rows="3" placeholder="Enter email body">
                        </textarea>
                        </tyl-form-field>

                        <!-- <tyl-button *ngIf="!selectedReport.ShowReportOptions" style="float:right; color: black;" image="post.png" translate label="Report To Email(s)" (clickEvent)="runReportToEmail('PDF')"></tyl-button> -->
                    </div>
                </td>


            </tr>


        </table>


    <!-- <div style="padding-bottom: 10px" *ngIf="newFile">
        <add-file [buttonLabel]="'Browse'" [required]="true" (changes)="addFileChanges($event)"></add-file>
        <div *ngIf="fileError == true" style="color: #b71c1c; font-size: 75%; padding-left: 10px">
            Please select a file
        </div>
    </div> -->
</div>
<div class="flex-footer">
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png"
            label="Save" (clickEvent)="saveClick()" translate></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
        <!-- [disabled]="!archiveToStudentDigitalContent && !archiveToStudentPortfolio && !archiveToTCM"  -->
    </div>
</div>